
(function ($) {
	$(document).ready(function () {

		/**
		 * Carousel - Add active class to first indicator
		 */
		$('.carousel-block .carousel-indicators li:first-of-type').addClass('active');

		let carousel = new bootstrap.Carousel($(".carousel").get(0));

		let carouselInstances = [];

		$(".carousel-block").each(function () {
			let carouselId = $(".carousel", this).attr("id");

			let carouselOptions = {
				pause: false,
				ride: "",
			};

			if (!$(this).hasClass("autoplay-disabled")) {
				carouselOptions.ride = "carousel";

				$(".carousel-control-cycle-toggle", this).removeClass("oc-pause");

			} else {
				$(".carousel-control-cycle-toggle", this).addClass("oc-pause");

			}

			let carouselInstance = new bootstrap.Carousel($("#" + carouselId).get(0), carouselOptions);

			carouselInstances[carouselId] = carouselInstance;

		});

		/* Play trigger */
		$('.carousel-control-cycle-toggle').on("click", function () {

			var carouselId = $(this).closest(".carousel").attr("id");

			let carousel = bootstrap.Carousel.getInstance($("#" + carouselId).get(0));


			if ($(this).hasClass("oc-pause")) {

				carousel.cycle();

			} else {

				carousel.pause();

			}

		});

	});
})(jQuery);
